// extracted by mini-css-extract-plugin
export default {"nft_img":"Transaction_nft_img__89nX-","nft_img_auto":"Transaction_nft_img_auto__Ly3RN"};